import React, {FC, useEffect} from 'react';
import {NavLink} from 'react-router-dom';
import {useMsal} from "@azure/msal-react";
import PlaylistPlayIcon from '@mui/icons-material/PlaylistPlay';
import TimelineIcon from '@mui/icons-material/Timeline';
import HelpIcon from '@mui/icons-material/Help';
import LogoutIcon from '@mui/icons-material/Logout';
import SupportAgentIcon from '@mui/icons-material/SupportAgent';
import BusinessCenterIcon from '@mui/icons-material/BusinessCenter';
import {Button} from "@mui/material";
import {useAppDispatch, useAppSelector} from "../hooks/storeHooks";
import logo_white from '../logo_white.png';
import "./NavBar.scss";
import {getBalance} from '../reducers/billingReducer';
import useExecWithToken from '../utils/FetchUtils';
import BalanceSummary from './billing/BalanceSummary';
import {checkUserAllowed, Resource} from "../utils/RBACUtils";

const NavBar: FC<NavBarProps> = ReactComponent => {
    const dispatch = useAppDispatch();
    const execWithToken = useExecWithToken();

    const {instance} = useMsal();
    const userRoles = useAppSelector((state) => state.access.roles);
    const userEmail = useAppSelector((state) => state.access.userEmail);
    const sessionStarted = useAppSelector(state => state.session.sessionStarted);

    useEffect(() => {
        execWithToken((token) => dispatch(getBalance({token: token})));
    }, []);

    const hasAccess = (resource: Resource) => {
        {
            try {
                return checkUserAllowed(userRoles, resource);
            } catch (error) {
                console.log(error);
            }
            return false;
        }
    }

    return (
        <div className="nav-bar-container">
            <div className="logo-wrap">
                <img className="logo-wrap-img" src={logo_white}/>
            </div>

            {userEmail && (
                <p className="nav-bar-user-greeting"><span className="nav-bar-user-greeting-hi">Hi👋</span>{userEmail}</p>
            )}
            <BalanceSummary/>

            <div className="nav-bar-menu-container">
                <HeaderLink to="/" disabled={sessionStarted}>
                    <PlaylistPlayIcon/>
                    <span>Dashboard</span>
                </HeaderLink>
                <HeaderLink to="/billing" disabled={sessionStarted}>
                    <TimelineIcon/>
                    <span>My Account</span>
                </HeaderLink>
                {hasAccess(Resource.BACKOFFICE) && (
                    <HeaderLink to="/backoffice" disabled={sessionStarted}>
                        <BusinessCenterIcon/>
                        <span>Back Office</span>
                    </HeaderLink>
                )}
                <HeaderLink to="/help" disabled={sessionStarted}>
                    <HelpIcon/>
                    <span>Help</span>
                </HeaderLink>
            </div>

            <div className="nav-bar-menu-footer">
                <HeaderLink to="/contactUs" disabled={sessionStarted}>
                    <SupportAgentIcon/>
                    <span>Contact us</span>
                </HeaderLink>
                {/*<Button className="nav-bar-button" variant="text" href="https://enersound.com/cloud/" target="_blank">*/}
                {/*    Contact us*/}
                {/*</Button>*/}
                <Button className="nav-bar-button"
                        variant="text"
                        onClick={() => {
                            let activeAccount = instance.getActiveAccount();
                            instance
                                .logoutRedirect({account: activeAccount})
                                .then(result => {
                                    console.log('[On logout]', result);
                                    localStorage.removeItem('token');
                                    localStorage.removeItem('userEmail');
                                });
                        }}
                        startIcon={<LogoutIcon/>}>
                    logout
                </Button>
            </div>
        </div>
    )
}

const HeaderLink = (props: HeaderLinkProps) => {
    if (props.disabled) {
        // console.log('HeaderLink -> disabled', props.to)
        return <div className="nav-bar-menu disabled">{props.children}</div>
    }

    // console.log('HeaderLink -> normal?', props.to)
    return <NavLink className="nav-bar-menu" {...props}>{props.children}</NavLink>
}

const HeaderBtn = (props: HeaderLinkProps) => {
    if (props.disabled) {
        // console.log('HeaderLink -> disabled', props.to)
        return <div className="disabled">{props.children}</div>
    }

    // console.log('HeaderLink -> normal?', props.to)
    return <NavLink {...props}>{props.children}</NavLink>
}

type HeaderLinkProps = {
    to: string;
    disabled?: boolean;
    children?: React.JSX.Element | React.JSX.Element[];
}

type NavBarProps = {}

export default NavBar
